<template>
  <div class="item-container">
    <div class="item-icon" @mouseover="showContent">
      <div class="item-icon-img">
        <img :src="src" v-if="src" />
        <div v-if="score != undefined" class="item-score">{{ score }}</div>
      </div>

      <slot name="name">
        <div v-if="name" class="item-name">{{ name }}</div>
      </slot>
    </div>
    <div class="item-tips" v-show="show_tip">
      <div class="item-tips-content">
        <slot name="title"></slot>
        <div ref="contentElement"></div>
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import px2vw from '@/utils/px2vw';
import { text2html } from '@utils/utils';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
  src: {
    type: String,
    required: false,
  },
  size: {
    type: Number,
    default: 34,
    required: false,
  },
  name: {
    type: String,
  },
  title: {
    type: String,
  },
  score: {
    type: Number,
  },
  // computedStyle:{
  //   type: Object,
  // }
});

const contentElement = ref(null);
const show_tip = ref(false);


const showContent = () => {
  if (props.content) {
    show_tip.value = true;
    text2html(props.content, contentElement.value);
  } else {
    show_tip.value = false;
  }
};

onMounted(async () => {});
</script>
